import FaqForm from "./FaqForm";

export default function AddFaq() {
  return <FaqForm mode="add" />;
}
